import { CommonModalPropsI } from "@components/HOC/withModals";
import useApiRequests from "@services/http/useApiRequest";
import { ConfirmEmailRequest } from "@services/notifsEmails";
import { getFormValue, isEmptyForm } from "@utils/getFormValue";
import { useToasts } from "@utils/hooks/useToasts";
import { makeNotifs } from "@utils/makeNotifs";
import { useState } from "react";

interface Elems extends HTMLFormControlsCollection {
  [key: string]: any;
}

interface MyForm extends HTMLFormElement {
  readonly elements: Elems;
}

interface AddNotifsEmailControlI {
  readonly loading: boolean;

  onSubmit(e: React.FormEvent<MyForm>): void;
}

export const useAddNotifsEmailControl = (
  props: CommonModalPropsI
): AddNotifsEmailControlI => {
  const notifs = makeNotifs();
  const requests = useApiRequests();
  const { success } = useToasts();
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmit = async (e: React.FormEvent<MyForm>) => {
    e.preventDefault();
    setLoading(true);
    const elems = e.currentTarget.elements;
    const value = getFormValue(elems) as { email: string };
    if (isEmptyForm(value)) return setLoading(false);
    const response = await requests.enqueue(new ConfirmEmailRequest(value.email));
    if (!response) return;
    success(notifs.ok.check_email);
    props.handleClose();
  };

  return {
    loading : loading || requests.isLoading,
    onSubmit,
  };
};
